import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';
import { Card, CardSection, CardSectionFullBleed } from 'components/Card';

type Props = {
  className?: string;
  stats: {
    eyebrowLabel: string;
    heading: string;
    label: string;
  }[];
  pdf?: boolean;
};

export const GoalStats = ({ className, stats, pdf }: Props): JSX.Element => {
  return (
    <Card className={className || 'md-d:inline-block'}>
      <CardSectionFullBleed
        vertical
        className={twMerge(
          'md-d:divide-y divide-black-200 md:divide-x border border-black-200 rounded-md md:flex',
          classNames({
            /** @NOTE(juan): workaround, basically chrome when printing to PDF ignores print width and
             * defaults to XS viewport ALWAYS. So we need to force the MD viewport styles manually
             */
            'divide-x flex': pdf,
          }),
        )}
      >
        {stats.map(({ eyebrowLabel, heading, label }, i) => (
           
          <CardSection key={`${eyebrowLabel}-${i}`} className="flex-1" vertical>
            <p className="text-gray-600 text-sm leading-none mb-8">{eyebrowLabel}</p>

            <p className="text-3xl font-bold">{heading}</p>
            <span className="text-sm font-semibold">{label}</span>
          </CardSection>
        ))}
      </CardSectionFullBleed>
    </Card>
  );
};
